<template>
  <b-form @submit.prevent="passwordRequest">
    <h3 class="mb-4">Wachtwoord vergeten</h3>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="email" class="form-control" placeholder="E-mail" v-model="form.email" required/>
    </b-input-group>
    <p v-if="message" class="text-success">{{ message }}</p>
    <b-row>
      <b-col cols="12">
        <b-button variant="primary" class="px-4 mt-2" type="submit" :disabled="loading">
          Wachtwoord aanvragen
          <b-spinner v-show="loading" small type="grow"/>
        </b-button>
      </b-col>
    </b-row>
  </b-form>

</template>

<script>
    import axios from 'axios';

    export default {
        name: 'password-forgot',
        data() {
            return {
                form: {
                    email: null,
                },
                message: null,
                success: false,
                loading: false,
            }
        },
        methods: {
            async passwordRequest() {
                this.loading = true;
                const request = await axios.post(process.env.VUE_APP_API_URL + '/admin/auth/forgot-password', this.form).catch(error => error.response);
                if (request.status) {
                    this.message = 'Als dit emailadres bestaat in ons systeem, dan is er een email gestuurd naar bovenstaand adres met verdere instructies.';
                    this.loading = false;
                }
            }
        },
    }
</script>
